import produce from 'immer';
import {
  GET_STORE_CONFIGS_START,
  GET_STORE_CONFIGS_SUCCESS,
  GET_STORE_CONFIGS_FAILED,
  UPDATE_STORE_CONFIGS_START,
  UPDATE_STORE_CONFIGS_SUCCESS,
  UPDATE_STORE_CONFIGS_FAILED,
  UPDATE_STORE_SITE_MAP_START,
  UPDATE_STORE_SITE_MAP_SUCCESS,
  UPDATE_STORE_SITE_MAP_FAILED,
  GET_REWARD_BEHAVIOR_RULES_START,
  GET_REWARD_BEHAVIOR_RULES_SUCCESS,
  GET_REWARD_BEHAVIOR_RULES_FAILED,
  UPDATE_REWARD_BEHAVIOR_RULE_START,
  UPDATE_REWARD_BEHAVIOR_RULE_SUCCESS,
  UPDATE_REWARD_BEHAVIOR_RULE_FAILED,
  CHANGE_STORE_CONFIGS,
  CHANGE_HOMEPAGE_PROMO_CAROUSEL_CONFIG,
  CHANGE_HOMEPAGE_CAROUSEL_BUTTON_CATEGORY,
  GET_FOLLOW_UP_EMAILS_START,
  GET_FOLLOW_UP_EMAILS_SUCCESS,
  GET_FOLLOW_UP_EMAILS_FAILED,
  CHANGE_CAMPAIGN_EMAIL_CONFIGS,

  SAVE_NOTIFICATION_OPTIONS_START,
  SAVE_NOTIFICATION_OPTIONS_SUCCESS,
  SAVE_NOTIFICATION_OPTIONS_FAILED,

  GET_SOCIAL_MEDIA_CONFIGS_START,
  GET_SOCIAL_MEDIA_CONFIGS_SUCCESS,
  GET_SOCIAL_MEDIA_CONFIGS_FAILED,
  CHANGE_SOCIAL_MEDIA_CONFIG,
  SAVE_SOCIAL_MEDIA_CONFIGS_START,
  SAVE_SOCIAL_MEDIA_CONFIGS_SUCCESS,
  SAVE_SOCIAL_MEDIA_CONFIGS_FAILED,

  GET_SURVEY_QUESTION_CONFIGS_START,
  GET_SURVEY_QUESTION_CONFIGS_SUCCESS,
  GET_SURVEY_QUESTION_CONFIGS_FAILED,
  CHANGE_SURVEY_QUESTION_CONFIG,

  GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_START,
  GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_SUCCESS,
  GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_FAILED,
  GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_START,
  GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS,
  GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED,
  CHANGE_HOMEPAGE_WELCOME_BLOCK_CONFIGS,
  SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_START,
  SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED,
  GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_START,
  GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS,
  GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED,
  CHANGE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS,
  SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_START,
  SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED,
  GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_START,
  GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_SUCCESS,
  GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_FAILED,
  CHANGE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS,
  SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_START,
  SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_FAILED,
  GET_HOMEPAGE_CTA_BLOCK_CONFIGS_START,
  GET_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS,
  GET_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED,
  CHANGE_HOMEPAGE_CTA_BLOCK_CONFIGS,
  CHANGE_HOMEPAGE_CTA_CATEGORY,
  SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_START,
  SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED,
  GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_START,
  GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS,
  GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED,
  SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_START,
  SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED,
  GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_START,
  GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_SUCCESS,
  GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_FAILED,
  SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_START,
  SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_FAILED,
  GET_HOMEPAGE_TESTIMONIALS_CONFIGS_START,
  GET_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS,
  GET_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED,
  SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_START,
  SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED,
  GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_START,
  GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS,
  GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED,
  CHANGE_HOMEPAGE_REWARD_BLOCK_CONFIGS,
  SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_START,
  SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED,
  GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_START,
  GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS,
  GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED,
  CHANGE_HOMEPAGE_PREMIUM_CTA_CONFIGS,
  CHANGE_HOMEPAGE_PREMIUM_CTA_CATEGORY,
  SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_START,
  SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED,
  GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_START,
  GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS,
  GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED,
  SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_START,
  SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS,
  SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED,
  GET_APPOINTMENT_FORM_CONFIGS_START,
  GET_APPOINTMENT_FORM_CONFIGS_SUCCESS,
  GET_APPOINTMENT_FORM_CONFIGS_FAILED,
  CHANGE_APPOINTMENT_FORM_CONFIGS,
  SAVE_APPOINTMENT_FORM_CONFIGS_START,
  SAVE_APPOINTMENT_FORM_CONFIGS_SUCCESS,
  SAVE_APPOINTMENT_FORM_CONFIGS_FAILED,
  GET_ABOUT_US_PAGE_CONFIGS_START,
  GET_ABOUT_US_PAGE_CONFIGS_SUCCESS,
  GET_ABOUT_US_PAGE_CONFIGS_FAILED,
  CHANGE_ABOUT_US_PAGE_CONFIGS,
  SAVE_ABOUT_US_PAGE_CONFIGS_START,
  SAVE_ABOUT_US_PAGE_CONFIGS_SUCCESS,
  SAVE_ABOUT_US_PAGE_CONFIGS_FAILED,
  GET_BEFORE_AFTER_GALLERY_CONFIGS_START,
  GET_BEFORE_AFTER_GALLERY_CONFIGS_SUCCESS,
  GET_BEFORE_AFTER_GALLERY_CONFIGS_FAILED,
  SAVE_BEFORE_AFTER_GALLERY_CONFIGS_START,
  SAVE_BEFORE_AFTER_GALLERY_CONFIGS_SUCCESS,
  SAVE_BEFORE_AFTER_GALLERY_CONFIGS_FAILED,
  GET_STORE_CONTACTS_CONFIGS_START,
  GET_STORE_CONTACTS_CONFIGS_SUCCESS,
  GET_STORE_CONTACTS_CONFIGS_FAILED,
  SAVE_STORE_CONTACTS_CONFIGS_START,
  SAVE_STORE_CONTACTS_CONFIGS_SUCCESS,
  SAVE_STORE_CONTACTS_CONFIGS_FAILED,
  SAVE_STORE_NAME_START,
  SAVE_STORE_NAME_SUCCESS,
  SAVE_STORE_NAME_FAILED,
  GET_STORE_EMAILS_CONFIGS_START,
  GET_STORE_EMAILS_CONFIGS_SUCCESS,
  GET_STORE_EMAILS_CONFIGS_FAILED,
  CHANGE_STORE_EMAILS_CONFIGS,
  GET_STORE_CONFIGS_SUMMARY_START,
  GET_STORE_CONFIGS_SUMMARY_SUCCESS,
  GET_STORE_CONFIGS_SUMMARY_FAILED,
  GET_STORE_EMAILS_STYLE_START,
  GET_STORE_EMAILS_STYLE_SUCCESS,
  GET_STORE_EMAILS_STYLE_FAILED,
  CHANGE_STORE_EMAILS_STYLE_TEMPLATE,
  SET_SETTINGS_ACTIVE_TAB,
  GET_PAYMENT_INTEGRATIONS_START,
  GET_PAYMENT_INTEGRATIONS_SUCCESS,
  GET_PAYMENT_INTEGRATIONS_FAILED,
  GET_STORE_EMAILS_CONFIGS_DATA_START,
  GET_STORE_EMAILS_CONFIGS_DATA_SUCCESS,
  GET_STORE_EMAILS_CONFIGS_DATA_FAILED,
  SAVE_STORE_EMAILS_CONFIGS_DATA_START,
  SAVE_STORE_EMAILS_CONFIGS_DATA_SUCCESS,
  SAVE_STORE_EMAILS_CONFIGS_DATA_FAILED,
  GET_REQUEST_ACCESS_CONFIGS_START,
  GET_REQUEST_ACCESS_CONFIGS_SUCCESS,
  GET_REQUEST_ACCESS_CONFIGS_FAILED,
  GET_DEPOSIT_CONFIG_START,
  GET_DEPOSIT_CONFIG_SUCCESS,
  GET_DEPOSIT_CONFIG_FAILED,
  GET_SARP_UPDATE_CONFIG_START,
  GET_SARP_UPDATE_CONFIG_SUCCESS,
  GET_SARP_UPDATE_CONFIG_FAILED
} from '../actions/store_configs';

import {
  CHANGE_HOMEPAGE_CATEGORY_VALUE
} from '../actions/categories';

import {
  CHANGE_ACTIVE_STORE_SUCCESS,
} from '../actions/user';


const initialState = {
  storeConfigs: [],
  isEnabledRequestAccess: false,
  isNextechIntegrated: false,
  isModMedIntegrated: false,
  isDepositIntegrated: false,
  storeConfigsSummary: [],
  storeConfigsSummaryUpdatedAt: '',
  loadingStoreConfigsSummary: false,
  rewardConfigsToUpdate: null,
  storeSocialMediaConfigs: [],
  storeSurveyQuestionConfigs: [],
  storeEmailsConfigs: [],
  storeEmailsStyleTemplate: '',
  storeEmailsConfigsToUpdate: [],
  storeContacts: {},
  storeEmailsData: [],
  homepageCategoriesConfigs: [],
  homeCategories: [],
  homepageCategoryIds: [],
  homepageCategoryNames: [],
  homepageWelcomeBlockConfigs: [],
  homepageRewardBlockConfigs: [],
  homepageBlogBlockConfigs: {
    general: {},
    first: {},
    second: {},
    third: {}
  },
  homepagePremiumCTAConfigs: {
    general: {},
    first: {},
    second: {},
    third: {},
    fourth: {}
  },
  homepagePremiumCTAConfigsToUpdate: [],
  homepageAdditionalHeaderConfigs: {
    general: {},
    first: {},
    second: {},
    third: {},
    fourth: {}
  },
  homepageAdditionalBannersConfigs: [],
  homepageTestimonialsConfigs: {
    general: {},
    first: {},
    second: {},
    third: {},
    fourth: {},
    fifth: {}
  },
  homepageCTABlockConfigs: {
    general: {},
    vertical: {},
    horizontal_top: {},
    horizontal_bottom: {}
  },
  homepageCTABlockConfigsToUpdate: [],
  homepageInstagramBlockConfigs: [],
  homepageBenefitsBlockConfigs: [],
  aboutUsPageConfigs: {
    general: {},
    page_top_banner: {},
    main_welcome_section: {},
    provider_section: {},
    cta_full_section: {},
    cta_container_section: {},
  },
  aboutUsPageConfigsToUpdate: [],
  beforeAfterGalleryConfigs: {},
  loadingBeforeAfterGalleryConfigs: false,
  savingBeforeAfterGalleryConfigs: false,
  appointmentBlockConfigs: [],
  loadingAppointmentBlockConfigs: false,
  savingAppointmentBlockConfigs: false,
  fueActiveCampaign: [],
  rewardBehaviorRules: [],
  activeCampaignEvents: [],
  activeCampaignEventsEmailsToUpdate: [],
  activeCampaignEventsEmails: {},
  loadingStoreEmailsConfigs: false,
  loadingStoreEmailsStyleTemplate: false,
  loadingAboutUsPageConfigs: false,
  loadingStoreContactsConfigs: false,
  loadingStoreEmailsDataConfigs: false,
  savingStoreContactsConfigs: false,
  savingStoreName: false,
  loadingHomepagePromoCategoriesConfigs: false,
  loadingHomepageWelcomeBlockConfigs: false,
  loadingHomepageRewardBlockConfigs: false,
  loadingHomepageBlogBlockConfigs: false,
  loadingHomepagePremiumCTAConfigs: false,
  loadingHomepageAdditionalHeaderConfigs: false,
  loadingHomepageTestimonialsConfigs: false,
  loadingHomepageAdditionalBannersConfigs: false,
  savingHomepageWelcomeBlockConfigs: false,
  savingHomepageRewardBlockConfigs: false,
  savingHomepageBlogBlockConfigs: false,
  savingHomepagePremiumCTAConfigs: false,
  savingHomepageAdditionalHeaderConfigs: false,
  savingHomepageTestimonialsConfigs: false,
  savingHomepageAdditionalBannersConfigs: false,
  savingHomepageCTABlockConfigs: false,
  loadingHomepageInstagramBlockConfigs: false,
  savingHomepageInstagramBlockConfigs: false,
  loadingHomepageBenefitsBlockConfigs: false,
  savingHomepageBenefitsBlockConfigs: false,
  loadingStoreSocialMediaConfigs: false,
  loadingStoreSurveyQuestionConfigs: false,
  loadingSaveSocialMediaConfigs: false,
  loadingEditStoreName: false,
  loadingSaveEmails: false,
  loadingSaveFueEvents: false,
  errorSaveEmails: false,
  loadingEvents: false,
  loadingUpdateStoreConfigs: false,
  loadingUpdateStoreSiteMap: false,
  errorEvents: false,
  loading: false,
  error: false,
  settingsActiveTab: null,
  loadingStorePaymentsIntegrations: false,
  loadingHomepageCTABlockConfigs: false,
  loadingNotificationOptions: false,
  savingAboutUsPageConfigs: false,
  loadingRequestAccessConfig: false,
  loadingDepositConfig: false,
  loadingSARPUpdateConfig: false,
  isSARPUpdateEnabled: false
};


const formReducer = produce((state: IStoreConfigsState = initialState, action) => {
  switch (action.type) {
    case GET_STORE_CONFIGS_START: {
      state.loading = true;
      break;
    }

    case GET_STORE_CONFIGS_SUCCESS: {
      const {data} = action;
      state.storeConfigs = data.config;
      state.loading = false;
      break;
    }

    case GET_STORE_CONFIGS_FAILED: {
      state.loading = false;
      break;
    }

    case GET_REWARD_BEHAVIOR_RULES_START: {
      state.loading = true;
      break;
    }

    case GET_REWARD_BEHAVIOR_RULES_SUCCESS: {
      const {data} = action;

      state.rewardBehaviorRules = data.items;
      state.loading = false;
      state.error = false;
      break;
    }

    case GET_REWARD_BEHAVIOR_RULES_FAILED: {
      state.loading = false;
      break;
    }

    case UPDATE_REWARD_BEHAVIOR_RULE_START: {
      state.loading = true;
      break;
    }

    case UPDATE_REWARD_BEHAVIOR_RULE_SUCCESS: {
      const {data} = action;

      state.rewardBehaviorRules = state.rewardBehaviorRules.map((rule) => rule.rule_id === data.rule_id ? data : rule);
      state.loading = false;
      break;
    }

    case UPDATE_REWARD_BEHAVIOR_RULE_FAILED: {
      const {error} = action;
      state.loading = false;
      state.error = error;
      break;
    }

    case UPDATE_STORE_CONFIGS_START: {
      state.loadingUpdateStoreConfigs = true;
      break;
    }

    case UPDATE_STORE_CONFIGS_SUCCESS: {
      const {data} = action;

      state.storeConfigs = state.storeConfigs.map((config) => {
        const dataConfig = data.config.find((c) => c.path === config.path);
        return dataConfig ? { ...config, ...dataConfig } : config;
      });
      state.loadingUpdateStoreConfigs = false;
      state.rewardConfigsToUpdate = null;
      break;
    }

    case UPDATE_STORE_CONFIGS_FAILED: {
      const {error} = action;
      state.loadingUpdateStoreConfigs = false;
      state.error = error;
      break;
    }

    case UPDATE_STORE_SITE_MAP_START: {
      state.loadingUpdateStoreSiteMap = true;
      break;
    }

    case UPDATE_STORE_SITE_MAP_SUCCESS: {
      state.loadingUpdateStoreSiteMap = false;
      break;
    }

    case UPDATE_STORE_SITE_MAP_FAILED: {
      state.loadingUpdateStoreSiteMap = false;
      break;
    }

    case CHANGE_STORE_CONFIGS: {
      const {name, checked, targetType, value} = action;

      state.storeConfigs = state.storeConfigs.map((config) => {
        if (config.path === name && targetType === 'checkbox' && name !== 'advanced/modules_disable_output/Magento_Review') {
          return { ...config, value: checked ? 1 : 0 };
        }

        if (config.path === name && targetType === 'checkbox' && name === 'advanced/modules_disable_output/Magento_Review') {
          return { ...config, value: checked ? 0 : 1 };
        }

        if (config.path === name && targetType !== 'checkbox') {
          return { ...config, value};
        }

        return config;
      });

      if (name == 'rewardpoints/general/enabled') {
        state.rewardConfigsToUpdate = {path: name, value: checked ? 1 : 0};
      }

      state.loading = false;
      break;
    }

    case GET_FOLLOW_UP_EMAILS_START: {
      state.loading = true;
      break;
    }

    case GET_FOLLOW_UP_EMAILS_SUCCESS: {
      const {campaigns, events, emails} = action;
      state.fueActiveCampaign = campaigns.items.filter((item) => item.status === 1);
      state.activeCampaignEvents = events.items.filter((item) => item.campaign_id === state.fueActiveCampaign[0].id);
      state.activeCampaignEventsEmails = state.activeCampaignEvents.reduce(
        (acc, event) => ({...acc, [event.id]: emails.items.filter((item) => item.event_id === event.id)}), {}
      );
      state.loading = false;
      state.error = false;
      break;
    }

    case GET_FOLLOW_UP_EMAILS_FAILED: {
      state.loading = false;
      state.error = true;
      break;
    }

    case CHANGE_CAMPAIGN_EMAIL_CONFIGS: {
      const {name, actionType, value, checked, emailId, eventId} = action;

      if (actionType === 'checkbox') {
        state.activeCampaignEventsEmails[eventId] = state.activeCampaignEventsEmails[eventId].map((email) => {
          return email.id === emailId ? {...email, status: checked ? 1 : 0} : email;
        });

        const shouldChangeEventStatus = state.activeCampaignEventsEmails[eventId].filter((email) => email.status == 1);

        if (!shouldChangeEventStatus.length) {
          state.activeCampaignEvents = state.activeCampaignEvents.map((event) => event.id === eventId ? {...event, status: 0} : event);
        } else {
          state.activeCampaignEvents = state.activeCampaignEvents.map((event) => event.id === eventId ? {...event, status: 1} : event);
        }
      }

      if (actionType !== 'checkbox') {
        state.activeCampaignEventsEmails[eventId] = state.activeCampaignEventsEmails[eventId].map((email) => {
          return email.id === emailId ? {...email, [name]: value} : email;
        });
      }

      state.activeCampaignEventsEmailsToUpdate = [...state.activeCampaignEventsEmailsToUpdate, ...state.activeCampaignEventsEmails[eventId]];
      state.activeCampaignEventsEmailsToUpdate = [...state.activeCampaignEventsEmailsToUpdate.reduce((map, obj) => map.set(obj.id, obj), new Map()).values()];

      break;
    }

    case SAVE_NOTIFICATION_OPTIONS_START: {
      state.loadingNotificationOptions = true;
      break;
    }

    case SAVE_NOTIFICATION_OPTIONS_SUCCESS: {
      state.activeCampaignEventsEmailsToUpdate = [];
      state.loadingNotificationOptions = false;
      state.errorSaveEmails = false;
      state.loading = false;
      state.rewardConfigsToUpdate = null;
      break;
    }

    case SAVE_NOTIFICATION_OPTIONS_FAILED: {
      state.loadingNotificationOptions = false;
      state.errorSaveEmails = true;
      break;
    }

    case GET_SOCIAL_MEDIA_CONFIGS_START: {
      state.loadingStoreSocialMediaConfigs = true;
      break;
    }

    case GET_SOCIAL_MEDIA_CONFIGS_SUCCESS: {
      const {data} = action;
      state.storeSocialMediaConfigs = data.config;
      state.loadingStoreSocialMediaConfigs = false;
      break;
    }

    case GET_SOCIAL_MEDIA_CONFIGS_FAILED: {
      state.loadingStoreSocialMediaConfigs = false;
      break;
    }

    case CHANGE_SOCIAL_MEDIA_CONFIG: {
      const {name, value} = action;

      state.storeSocialMediaConfigs = state.storeSocialMediaConfigs.map((config) => {
        return config.path === name ? {...config, value} : config;
      });
      break;
    }

    case SAVE_SOCIAL_MEDIA_CONFIGS_START: {
      state.loadingSaveSocialMediaConfigs = true;
      break;
    }

    case SAVE_SOCIAL_MEDIA_CONFIGS_SUCCESS: {
      state.loadingSaveSocialMediaConfigs = false;
      break;
    }

    case SAVE_SOCIAL_MEDIA_CONFIGS_FAILED: {
      state.loadingSaveSocialMediaConfigs = false;
      break;
    }

    case GET_SURVEY_QUESTION_CONFIGS_START: {
      state.loadingStoreSurveyQuestionConfigs = true;
      break;
    }

    case GET_SURVEY_QUESTION_CONFIGS_SUCCESS: {
      const {data} = action;
      state.storeSurveyQuestionConfigs = data.config;
      state.loadingStoreSurveyQuestionConfigs = false;
      break;
    }

    case GET_SURVEY_QUESTION_CONFIGS_FAILED: {
      state.loadingStoreSurveyQuestionConfigs = false;
      break;
    }

    case CHANGE_SURVEY_QUESTION_CONFIG: {
      const { name, checked, targetType, value, data } = action;

      state.storeSurveyQuestionConfigs = state.storeSurveyQuestionConfigs.map((config) => {
        if (data && Object.keys(data).length > 0 && config.path === name) {
          const values = String(config.value) ? JSON.parse(String(config.value)) : {};
          const surveyValues = !Array.isArray(values) ? values : {};

          if (data.action === 'add') {
            surveyValues[data.key] = { value: '' };
          }

          if (data.action === 'update' && data.key in surveyValues) {
            surveyValues[data.key] = { value };
          }

          if (data.action === 'delete' && data.key in surveyValues) {
            Reflect.deleteProperty(surveyValues, data.key);
          }

          return { ...config, value: JSON.stringify(surveyValues) };
        }

        if (config.path === name && targetType === 'checkbox') {
          return { ...config, value: checked ? 1 : 0 };
        }

        if (config.path === name && targetType !== 'checkbox') {
          return { ...config, value};
        }

        return config;
      });

      break;
    }

    case GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_START: {
      state.loadingHomepagePromoCategoriesConfigs = true;
      break;
    }

    case GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_SUCCESS: {
      const {data} = action;

      state.homepageCategoriesConfigs = data.config;
      state.homeCategories = state.homepageCategoriesConfigs.filter((config) => (
        config.path.includes('store_info/home_tabs/carousel_') && config.path.includes('_category_id')
      ));
      state.homepageCategoryIds = data.config.filter((config) => (
        config.path.includes('store_info/home_tabs/carousel_') && config.path.includes('category_id')
      )).map((config) => config.value);
      state.homepageCategoryNames = data.config.filter((config) => (
        config.path.includes('store_info/home_tabs/carousel_') && config.path.includes('title')
      )).map((config) => config.value);
      state.loadingHomepagePromoCategoriesConfigs = false;
      break;
    }

    case GET_HOMEPAGE_PROMO_CATEGORIES_CONFIGS_FAILED: {
      const {error} = action;
      console.log(error);
      state.loadingHomepagePromoCategoriesConfigs = false;
      break;
    }

    case CHANGE_HOMEPAGE_PROMO_CAROUSEL_CONFIG: {
      const {name, checked, targetType, value} = action;

      state.homepageCategoriesConfigs = state.homepageCategoriesConfigs.map((config) => {
        if (config.path === name && targetType === 'checkbox') {
          return { ...config, value: checked ? '1' : '0' };
        }

        if (config.path === name && targetType !== 'checkbox') {
          return { ...config, value};
        }

        return config;
      });

      break;
    }

    case CHANGE_HOMEPAGE_CAROUSEL_BUTTON_CATEGORY: {
      const {actionName, categoryId, path} = action;

      if (actionName === 'clear') {
        state.homepageCategoriesConfigs = state.homepageCategoriesConfigs.map((config) => (
          config.path === path ? {...config, value: null} : config
        ));
      }

      if (actionName === 'select-option') {
        state.homepageCategoriesConfigs = state.homepageCategoriesConfigs.map((config) => (
          config.path === path ? {...config, value: categoryId} : config
        ));
      }

      break;
    }

    case GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_START: {
      state.loadingHomepageWelcomeBlockConfigs = true;
      break;
    }

    case GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS: {
      const {data} = action;
      state.homepageWelcomeBlockConfigs = data.config;
      state.loadingHomepageWelcomeBlockConfigs = false;
      break;
    }

    case GET_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED: {
      state.loadingHomepageWelcomeBlockConfigs = false;
      break;
    }

    case CHANGE_HOMEPAGE_WELCOME_BLOCK_CONFIGS: {
      const { configPath, checked, configType, value} = action;

      if (configType === 'checkbox') {
        state.homepageWelcomeBlockConfigs = state.homepageWelcomeBlockConfigs.map((config) => (
          config.path === configPath ? {...config, value: checked ? '1' : '0'} : config
        ));
      }

      if (configType === 'text' || configType === 'textarea') {
        state.homepageWelcomeBlockConfigs = state.homepageWelcomeBlockConfigs.map((config) => (
          config.path === configPath ? {...config, value} : config
        ));
      }

      break;
    }

    case SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_START: {
      state.savingHomepageWelcomeBlockConfigs = true;
      break;
    }

    case SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_SUCCESS: {
      const {data} = action;
      state.homepageWelcomeBlockConfigs = data.config;
      state.savingHomepageWelcomeBlockConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_WELCOME_BLOCK_CONFIGS_FAILED: {
      state.savingHomepageWelcomeBlockConfigs = false;
      break;
    }

    case GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_START: {
      state.loadingHomepageInstagramBlockConfigs = true;
      break;
    }

    case GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS: {
      const {data} = action;
      state.homepageInstagramBlockConfigs = data.config.map((config) => config.value === null ? {...config, value: ''} : config);
      state.loadingHomepageInstagramBlockConfigs = false;
      break;
    }

    case GET_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED: {
      state.loadingHomepageInstagramBlockConfigs = false;
      break;
    }

    case CHANGE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS: {
      const { configPath, checked, configType, value} = action;

      if (configType === 'checkbox') {
        state.homepageInstagramBlockConfigs = state.homepageInstagramBlockConfigs.map((config) => (
          config.path === configPath ? {...config, value: checked ? '1' : '0'} : config
        ));
      }

      if (configType === 'text' || configType === 'textarea') {
        state.homepageInstagramBlockConfigs = state.homepageInstagramBlockConfigs.map((config) => (
          config.path === configPath ? {...config, value} : config
        ));
      }

      break;
    }

    case SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_START: {
      state.savingHomepageInstagramBlockConfigs = true;
      break;
    }

    case SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_SUCCESS: {
      const {data} = action;
      state.homepageInstagramBlockConfigs = data.config;
      state.savingHomepageInstagramBlockConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_INSTAGRAM_BLOCK_CONFIGS_FAILED: {
      state.savingHomepageInstagramBlockConfigs = false;
      break;
    }

    case GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_START: {
      state.loadingHomepageBenefitsBlockConfigs = true;
      break;
    }

    case GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_SUCCESS: {
      const {data} = action;
      state.homepageBenefitsBlockConfigs = data.config.map((config) => config.value === null ? {...config, value: ''} : config);
      state.loadingHomepageBenefitsBlockConfigs = false;
      break;
    }

    case GET_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_FAILED: {
      state.loadingHomepageBenefitsBlockConfigs = false;
      break;
    }

    case CHANGE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS: {
      const { configPath, checked, configType, value} = action;

      if (configType === 'checkbox') {
        state.homepageBenefitsBlockConfigs = state.homepageBenefitsBlockConfigs.map((config) => (
          config.path === configPath ? {...config, value: checked ? '1' : '0'} : config
        ));
      }

      if (configType === 'text' || configType === 'textarea') {
        state.homepageBenefitsBlockConfigs = state.homepageBenefitsBlockConfigs.map((config) => (
          config.path === configPath ? {...config, value} : config
        ));
      }

      break;
    }

    case SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_START: {
      state.savingHomepageBenefitsBlockConfigs = true;
      break;
    }

    case SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_SUCCESS: {
      const {data} = action;
      state.homepageBenefitsBlockConfigs = data.config;
      state.savingHomepageBenefitsBlockConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_BENEFITS_BLOCK_CONFIGS_FAILED: {
      state.savingHomepageBenefitsBlockConfigs = false;
      break;
    }

    case GET_HOMEPAGE_CTA_BLOCK_CONFIGS_START: {
      state.loadingHomepageCTABlockConfigs = true;
      break;
    }

    case GET_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      config.forEach((config) => {
        if (config.path.includes('is_cta_enabled')) {
          state.homepageCTABlockConfigs.general = {
            ...state.homepageCTABlockConfigs.general,
            [config.path]: config.value
          };
        }

        if (
          config.path.includes('cta_vertical') || config.path.includes('cta_image_1')) {
          state.homepageCTABlockConfigs.vertical = {
            ...state.homepageCTABlockConfigs.vertical,
            [config.path]: config.value
          };
        }

        if (config.path.includes('cta_horizontal_top') || config.path.includes('cta_image_2')) {
          state.homepageCTABlockConfigs.horizontal_top = {
            ...state.homepageCTABlockConfigs.horizontal_top,
            [config.path]: config.value
          };
        }

        if (config.path.includes('cta_horizontal_bottom') || config.path.includes('cta_image_3')) {
          state.homepageCTABlockConfigs.horizontal_bottom = {
            ...state.homepageCTABlockConfigs.horizontal_bottom,
            [config.path]: config.value
          };
        }
      });

      state.loadingHomepageCTABlockConfigs = false;
      break;
    }

    case GET_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED: {
      state.loadingHomepageCTABlockConfigs = false;
      break;
    }

    case CHANGE_HOMEPAGE_CTA_BLOCK_CONFIGS: {
      const { configPath, checked, configType, value, configObject} = action;

      const isConfigExist = state.homepageCTABlockConfigsToUpdate.find((config) => config.path === configPath);

      if (configType === 'checkbox') {
        if (isConfigExist) {
          state.homepageCTABlockConfigsToUpdate = state.homepageCTABlockConfigsToUpdate.map((config) => (
            config.path === configPath ? {...config, value: checked ? 1 : 0} : config
          ));
        } else {
          state.homepageCTABlockConfigsToUpdate = [
            ...state.homepageCTABlockConfigsToUpdate,
            {path: configPath, value: checked ? 1 : 0}
          ];
        }

        state.homepageCTABlockConfigs[configObject] = {
          ...state.homepageCTABlockConfigs[configObject],
          [configPath]: checked ? '1' : '0'
        };
      }

      if (configType === 'text' || configType === 'radio') {
        isConfigExist ?
          state.homepageCTABlockConfigsToUpdate = state.homepageCTABlockConfigsToUpdate.map((config) => (
            config.path === configPath ? {...config, value} : config
          ))
          :
          state.homepageCTABlockConfigsToUpdate = [
            ...state.homepageCTABlockConfigsToUpdate,
            {path: configPath, value}
          ];

        state.homepageCTABlockConfigs[configObject] = {
          ...state.homepageCTABlockConfigs[configObject],
          [configPath]: value
        };
      }

      break;
    }

    case CHANGE_HOMEPAGE_CTA_CATEGORY: {
      const {value, configTab, configPath} = action;

      const isConfigExist = state.homepageCTABlockConfigsToUpdate.find((config) => config.path === configPath);

      isConfigExist ?
        state.homepageCTABlockConfigsToUpdate = state.homepageCTABlockConfigsToUpdate.map((config) => (
          config.path === configPath ? {...config, value: value?.id ? value.id : ''} : config
        ))
        :
        state.homepageCTABlockConfigsToUpdate = [
          ...state.homepageCTABlockConfigsToUpdate,
          {path: configPath, value: value?.id ? value.id : ''}
        ];

      state.homepageCTABlockConfigs[configTab] = {
        ...state.homepageCTABlockConfigs[configTab],
        [configPath]: value?.id ? value.id : ''
      };

      break;
    }

    case SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_START: {
      state.savingHomepageCTABlockConfigs = true;
      break;
    }

    case SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      config.forEach((config) => {
        if (config.path.includes('is_cta_enabled')) {
          state.homepageCTABlockConfigs.general = {
            ...state.homepageCTABlockConfigs.general,
            [config.path]: config.value
          };
        }

        if (
          config.path.includes('cta_vertical') || config.path.includes('cta_image_1')) {
          state.homepageCTABlockConfigs.vertical = {
            ...state.homepageCTABlockConfigs.vertical,
            [config.path]: config.value
          };
        }

        if (config.path.includes('cta_horizontal_top') || config.path.includes('cta_image_2')) {
          state.homepageCTABlockConfigs.horizontal_top = {
            ...state.homepageCTABlockConfigs.horizontal_top,
            [config.path]: config.value
          };
        }

        if (config.path.includes('cta_horizontal_bottom') || config.path.includes('cta_image_3')) {
          state.homepageCTABlockConfigs.horizontal_bottom = {
            ...state.homepageCTABlockConfigs.horizontal_bottom,
            [config.path]: config.value
          };
        }
      });
      state.homepageCTABlockConfigsToUpdate = initialState.homepageCTABlockConfigsToUpdate;
      state.savingHomepageCTABlockConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_CTA_BLOCK_CONFIGS_FAILED: {
      state.savingHomepageCTABlockConfigs = false;
      break;
    }

    case GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_START: {
      state.loadingHomepageAdditionalHeaderConfigs = true;
      break;
    }

    case GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      config.forEach((config) => {
        if (config.path.includes('is_additional_header_enable')) {
          state.homepageAdditionalHeaderConfigs.general = {
            ...state.homepageAdditionalHeaderConfigs.general,
            [config.path]: config.value
          };
        }

        if (config.path.includes('additional_header_first_item')) {
          state.homepageAdditionalHeaderConfigs.first = {
            ...state.homepageAdditionalHeaderConfigs.first,
            [config.path]: config.value
          };
        }

        if (config.path.includes('additional_header_second_item')) {
          state.homepageAdditionalHeaderConfigs.second = {
            ...state.homepageAdditionalHeaderConfigs.second,
            [config.path]: config.value
          };
        }

        if (config.path.includes('additional_header_third_item')) {
          state.homepageAdditionalHeaderConfigs.third = {
            ...state.homepageAdditionalHeaderConfigs.third,
            [config.path]: config.value
          };
        }

        if (config.path.includes('additional_header_fourth_item')) {
          state.homepageAdditionalHeaderConfigs.fourth = {
            ...state.homepageAdditionalHeaderConfigs.fourth,
            [config.path]: config.value
          };
        }
      });
      state.loadingHomepageAdditionalHeaderConfigs = false;
      break;
    }

    case GET_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED: {
      state.loadingHomepageAdditionalHeaderConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_START: {
      state.savingHomepageAdditionalHeaderConfigs = true;
      break;
    }

    case SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      config.forEach((config) => {
        if (config.path.includes('is_additional_header_enable')) {
          state.homepageAdditionalHeaderConfigs.general = {
            ...state.homepageAdditionalHeaderConfigs.general,
            [config.path]: config.value
          };
        }

        if (config.path.includes('additional_header_first_item')) {
          state.homepageAdditionalHeaderConfigs.first = {
            ...state.homepageAdditionalHeaderConfigs.first,
            [config.path]: config.value
          };
        }

        if (config.path.includes('additional_header_second_item')) {
          state.homepageAdditionalHeaderConfigs.second = {
            ...state.homepageAdditionalHeaderConfigs.second,
            [config.path]: config.value
          };
        }

        if (config.path.includes('additional_header_third_item')) {
          state.homepageAdditionalHeaderConfigs.third = {
            ...state.homepageAdditionalHeaderConfigs.third,
            [config.path]: config.value
          };
        }

        if (config.path.includes('additional_header_fourth_item')) {
          state.homepageAdditionalHeaderConfigs.fourth = {
            ...state.homepageAdditionalHeaderConfigs.fourth,
            [config.path]: config.value
          };
        }
      });
      state.savingHomepageAdditionalHeaderConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_ADDITIONAL_HEADER_CONFIGS_FAILED: {
      state.savingHomepageAdditionalHeaderConfigs = false;
      break;
    }

    case GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_START: {
      state.loadingHomepageAdditionalBannersConfigs = true;
      break;
    }

    case GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_SUCCESS: {
      const {data} = action;
      state.homepageAdditionalBannersConfigs = data.config;
      state.loadingHomepageAdditionalBannersConfigs = false;
      break;
    }

    case GET_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_FAILED: {
      state.loadingHomepageAdditionalBannersConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_START: {
      state.savingHomepageAdditionalBannersConfigs = true;
      break;
    }

    case SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_SUCCESS: {
      const {data} = action;
      state.homepageAdditionalBannersConfigs = data.config;
      state.savingHomepageAdditionalBannersConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_ADDITIONAL_BANNERS_CONFIGS_FAILED: {
      state.savingHomepageAdditionalBannersConfigs = false;
      break;
    }

    case GET_HOMEPAGE_TESTIMONIALS_CONFIGS_START: {
      state.loadingHomepageTestimonialsConfigs = true;
      break;
    }

    case GET_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS: {
      const {data} = action;

      data.config.forEach((config) => {
        if (config.path.includes('is_testimonails_enabled')) {
          state.homepageTestimonialsConfigs.general = {
            ...state.homepageTestimonialsConfigs.general,
            [config.path]: config.value
          };
        }

        if (config.path.includes('first_testimonail')) {
          state.homepageTestimonialsConfigs.first = {
            ...state.homepageTestimonialsConfigs.first,
            [config.path]: config.value
          };
        }

        if (config.path.includes('second_testimonail')) {
          state.homepageTestimonialsConfigs.second = {
            ...state.homepageTestimonialsConfigs.second,
            [config.path]: config.value
          };
        }

        if (config.path.includes('third_testimonail')) {
          state.homepageTestimonialsConfigs.third = {
            ...state.homepageTestimonialsConfigs.third,
            [config.path]: config.value
          };
        }

        if (config.path.includes('fourth_testimonail')) {
          state.homepageTestimonialsConfigs.fourth = {
            ...state.homepageTestimonialsConfigs.fourth,
            [config.path]: config.value
          };
        }

        if (config.path.includes('fifth_testimonail')) {
          state.homepageTestimonialsConfigs.fifth = {
            ...state.homepageTestimonialsConfigs.fifth,
            [config.path]: config.value
          };
        }
      });

      state.loadingHomepageTestimonialsConfigs = false;
      break;
    }

    case GET_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED: {
      state.loadingHomepageTestimonialsConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_START: {
      state.savingHomepageTestimonialsConfigs = true;
      break;
    }

    case SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_SUCCESS: {
      const {data} = action;

      data.config.forEach((config) => {
        if (config.path.includes('is_testimonails_enabled')) {
          state.homepageTestimonialsConfigs.general = {
            ...state.homepageTestimonialsConfigs.general,
            [config.path]: config.value
          };
        }

        if (config.path.includes('first_testimonail')) {
          state.homepageTestimonialsConfigs.first = {
            ...state.homepageTestimonialsConfigs.first,
            [config.path]: config.value
          };
        }

        if (config.path.includes('second_testimonail')) {
          state.homepageTestimonialsConfigs.second = {
            ...state.homepageTestimonialsConfigs.second,
            [config.path]: config.value
          };
        }

        if (config.path.includes('third_testimonail')) {
          state.homepageTestimonialsConfigs.third = {
            ...state.homepageTestimonialsConfigs.third,
            [config.path]: config.value
          };
        }

        if (config.path.includes('fourth_testimonail')) {
          state.homepageTestimonialsConfigs.fourth = {
            ...state.homepageTestimonialsConfigs.fourth,
            [config.path]: config.value
          };
        }

        if (config.path.includes('fifth_testimonail')) {
          state.homepageTestimonialsConfigs.fifth = {
            ...state.homepageTestimonialsConfigs.fifth,
            [config.path]: config.value
          };
        }
      });

      state.savingHomepageTestimonialsConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_TESTIMONIALS_CONFIGS_FAILED: {
      state.savingHomepageTestimonialsConfigs = false;
      break;
    }

    case GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_START: {
      state.loadingHomepageBlogBlockConfigs = true;
      break;
    }

    case GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS: {
      const {data} = action;

      data.config.forEach((config) => {
        if (config.path.includes('premium_plus_blog_')) {
          state.homepageBlogBlockConfigs.general = {
            ...state.homepageBlogBlockConfigs.general,
            [config.path]: config.value
          };
        }

        if (config.path.includes('first_item')) {
          state.homepageBlogBlockConfigs.first = {
            ...state.homepageBlogBlockConfigs.first,
            [config.path]: config.value
          };
        }

        if (config.path.includes('second_item')) {
          state.homepageBlogBlockConfigs.second = {
            ...state.homepageBlogBlockConfigs.second,
            [config.path]: config.value
          };
        }

        if (config.path.includes('third_item')) {
          state.homepageBlogBlockConfigs.third = {
            ...state.homepageBlogBlockConfigs.third,
            [config.path]: config.value
          };
        }
      });
      state.loadingHomepageBlogBlockConfigs = false;
      break;
    }

    case GET_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED: {
      state.loadingHomepageBlogBlockConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_START: {
      state.savingHomepageBlogBlockConfigs = true;
      break;
    }

    case SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_SUCCESS: {
      const {data} = action;

      data.config.forEach((config) => {
        if (config.path.includes('premium_plus_blog_')) {
          state.homepageBlogBlockConfigs.general = {
            ...state.homepageBlogBlockConfigs.general,
            [config.path]: config.value
          };
        }

        if (config.path.includes('first_item')) {
          state.homepageBlogBlockConfigs.first = {
            ...state.homepageBlogBlockConfigs.first,
            [config.path]: config.value
          };
        }

        if (config.path.includes('second_item')) {
          state.homepageBlogBlockConfigs.second = {
            ...state.homepageBlogBlockConfigs.second,
            [config.path]: config.value
          };
        }

        if (config.path.includes('third_item')) {
          state.homepageBlogBlockConfigs.third = {
            ...state.homepageBlogBlockConfigs.third,
            [config.path]: config.value
          };
        }
      });
      state.savingHomepageBlogBlockConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_BLOG_BLOCK_CONFIGS_FAILED: {
      state.savingHomepageBlogBlockConfigs = false;
      break;
    }

    case GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_START: {
      state.loadingHomepagePremiumCTAConfigs = true;
      break;
    }

    case GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      config.forEach((config) => {
        if (
          config.path.includes('is_premium_plus_cta_enable') ||
          config.path.includes('premium_plus_cta_main_title')) {
          state.homepagePremiumCTAConfigs.general = {
            ...state.homepagePremiumCTAConfigs.general,
            [config.path]: config.value
          };
        }

        if (
          config.path.includes('premium_plus_cta_first_item')) {
          state.homepagePremiumCTAConfigs.first = {
            ...state.homepagePremiumCTAConfigs.first,
            [config.path]: config.value
          };
        }

        if (config.path.includes('premium_plus_cta_second_item')) {
          state.homepagePremiumCTAConfigs.second = {
            ...state.homepagePremiumCTAConfigs.second,
            [config.path]: config.value
          };
        }

        if (config.path.includes('premium_plus_cta_third_item')) {
          state.homepagePremiumCTAConfigs.third = {
            ...state.homepagePremiumCTAConfigs.third,
            [config.path]: config.value
          };
        }

        if (config.path.includes('premium_plus_cta_fourth_item')) {
          state.homepagePremiumCTAConfigs.fourth = {
            ...state.homepagePremiumCTAConfigs.fourth,
            [config.path]: config.value
          };
        }
      });
      state.loadingHomepagePremiumCTAConfigs = false;
      break;
    }

    case GET_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED: {
      state.loadingHomepagePremiumCTAConfigs = false;
      break;
    }

    case CHANGE_HOMEPAGE_PREMIUM_CTA_CONFIGS: {
      const { configPath, checked, configType, value, configObject} = action;

      const isConfigExist = state.homepagePremiumCTAConfigsToUpdate.find((config) => config.path === configPath);

      if (configType === 'checkbox') {
        if (isConfigExist) {
          state.homepagePremiumCTAConfigsToUpdate = state.homepagePremiumCTAConfigsToUpdate.map((config) => (
            config.path === configPath ? {...config, value: checked ? 1 : 0} : config
          ));
        } else {
          state.homepagePremiumCTAConfigsToUpdate = [
            ...state.homepagePremiumCTAConfigsToUpdate,
            {path: configPath, value: checked ? 1 : 0}
          ];
        }

        state.homepagePremiumCTAConfigs[configObject] = {
          ...state.homepagePremiumCTAConfigs[configObject],
          [configPath]: checked ? '1' : '0'
        };
      }

      if (configType === 'text' || configType === 'radio') {
        isConfigExist ?
          state.homepagePremiumCTAConfigsToUpdate = state.homepagePremiumCTAConfigsToUpdate.map((config) => (
            config.path === configPath ? {...config, value} : config
          ))
          :
          state.homepagePremiumCTAConfigsToUpdate = [
            ...state.homepagePremiumCTAConfigsToUpdate,
            {path: configPath, value}
          ];

        state.homepagePremiumCTAConfigs[configObject] = {
          ...state.homepagePremiumCTAConfigs[configObject],
          [configPath]: value
        };
      }

      break;
    }

    case CHANGE_HOMEPAGE_PREMIUM_CTA_CATEGORY: {
      const {value, configTab, configPath} = action;

      const isConfigExist = state.homepagePremiumCTAConfigsToUpdate.find((config) => config.path === configPath);

      isConfigExist ?
        state.homepagePremiumCTAConfigsToUpdate = state.homepagePremiumCTAConfigsToUpdate.map((config) => (
          config.path === configPath ? {...config, value: value?.id ? value.id : ''} : config
        ))
        :
        state.homepagePremiumCTAConfigsToUpdate = [
          ...state.homepagePremiumCTAConfigsToUpdate,
          {path: configPath, value: value?.id ? value.id : ''}
        ];

      state.homepagePremiumCTAConfigs[configTab] = {
        ...state.homepagePremiumCTAConfigs[configTab],
        [configPath]: value?.id ? value.id : ''
      };
      break;
    }

    case SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_START: {
      state.savingHomepagePremiumCTAConfigs = true;
      break;
    }

    case SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      config.forEach((config) => {
        if (config.path.includes('is_premium_plus_cta_enable' || 'premium_plus_cta_main_title')) {
          state.homepageCTABlockConfigs.general = {
            ...state.homepageCTABlockConfigs.general,
            [config.path]: config.value
          };
        }

        if (
          config.path.includes('premium_plus_cta_first_item')) {
          state.homepageCTABlockConfigs.first = {
            ...state.homepageCTABlockConfigs.first,
            [config.path]: config.value
          };
        }

        if (config.path.includes('premium_plus_cta_second_item')) {
          state.homepageCTABlockConfigs.second = {
            ...state.homepageCTABlockConfigs.second,
            [config.path]: config.value
          };
        }

        if (config.path.includes('premium_plus_cta_third_item')) {
          state.homepageCTABlockConfigs.third = {
            ...state.homepageCTABlockConfigs.third,
            [config.path]: config.value
          };
        }

        if (config.path.includes('premium_plus_cta_fourth_item')) {
          state.homepageCTABlockConfigs.fourth = {
            ...state.homepageCTABlockConfigs.fourth,
            [config.path]: config.value
          };
        }
      });
      state.savingHomepagePremiumCTAConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_PREMIUM_CTA_CONFIGS_FAILED: {
      state.savingHomepagePremiumCTAConfigs = false;
      break;
    }


    case GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_START: {
      state.loadingHomepageRewardBlockConfigs = true;
      break;
    }

    case GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS: {
      const {data} = action;
      state.homepageRewardBlockConfigs = data.config;
      state.loadingHomepageRewardBlockConfigs = false;
      break;
    }

    case GET_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED: {
      state.loadingHomepageRewardBlockConfigs = false;
      break;
    }

    case CHANGE_HOMEPAGE_REWARD_BLOCK_CONFIGS: {
      const { configPath, checked, configType, value} = action;

      if (configType === 'checkbox') {
        state.homepageRewardBlockConfigs = state.homepageRewardBlockConfigs.map((config) => (
          config.path === configPath ? {...config, value: checked ? '1' : '0'} : config
        ));
      }

      if (configType === 'text' || configType === 'textarea') {
        state.homepageRewardBlockConfigs = state.homepageRewardBlockConfigs.map((config) => (
          config.path === configPath ? {...config, value} : config
        ));
      }

      break;
    }

    case SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_START: {
      state.savingHomepageRewardBlockConfigs = true;
      break;
    }

    case SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_SUCCESS: {
      const {data} = action;
      state.homepageRewardBlockConfigs = data.config;
      state.savingHomepageRewardBlockConfigs = false;
      break;
    }

    case SAVE_HOMEPAGE_REWARD_BLOCK_CONFIGS_FAILED: {
      state.savingHomepageRewardBlockConfigs = false;
      break;
    }

    case GET_APPOINTMENT_FORM_CONFIGS_START: {
      state.loadingAppointmentBlockConfigs = true;
      break;
    }

    case GET_APPOINTMENT_FORM_CONFIGS_SUCCESS: {
      const {data} = action;
      state.appointmentBlockConfigs = data.config;
      state.loadingAppointmentBlockConfigs = false;
      break;
    }

    case GET_APPOINTMENT_FORM_CONFIGS_FAILED: {
      state.loadingAppointmentBlockConfigs = false;
      break;
    }

    case CHANGE_APPOINTMENT_FORM_CONFIGS: {
      const { configPath, checked, configType, value} = action;

      if (configType === 'checkbox') {
        state.appointmentBlockConfigs = state.appointmentBlockConfigs.map((config) => (
          config.path === configPath ? {...config, value: checked ? '1' : '0'} : config
        ));
      }

      if (configType === 'text' || configType === 'textarea') {
        state.appointmentBlockConfigs = state.appointmentBlockConfigs.map((config) => (
          config.path === configPath ? {...config, value} : config
        ));
      }

      break;
    }

    case SAVE_APPOINTMENT_FORM_CONFIGS_START: {
      state.savingAppointmentBlockConfigs = true;
      break;
    }

    case SAVE_APPOINTMENT_FORM_CONFIGS_SUCCESS: {
      const {data} = action;
      state.appointmentBlockConfigs = data.config;
      state.savingAppointmentBlockConfigs = false;
      break;
    }

    case SAVE_APPOINTMENT_FORM_CONFIGS_FAILED: {
      state.savingAppointmentBlockConfigs = false;
      break;
    }

    case GET_ABOUT_US_PAGE_CONFIGS_START: {
      state.loadingAboutUsPageConfigs = true;
      break;
    }

    case GET_ABOUT_US_PAGE_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      config.forEach((config) => {
        if (config.path.includes('is_about_us_page_enabled')) {
          state.aboutUsPageConfigs.general = {
            ...state.aboutUsPageConfigs.general,
            [config.path]: config.value
          };
        }

        if (config.path.includes('top_banner')) {
          state.aboutUsPageConfigs.page_top_banner = {
            ...state.aboutUsPageConfigs.page_top_banner,
            [config.path]: config.value
          };
        }

        if (config.path.includes('main_content')) {
          state.aboutUsPageConfigs.main_welcome_section = {
            ...state.aboutUsPageConfigs.main_welcome_section,
            [config.path]: config.value
          };
        }

        if (config.path.includes('provider')) {
          state.aboutUsPageConfigs.provider_section = {
            ...state.aboutUsPageConfigs.provider_section,
            [config.path]: config.value
          };
        }

        if (config.path.includes('cta_full')) {
          state.aboutUsPageConfigs.cta_full_section = {
            ...state.aboutUsPageConfigs.cta_full_section,
            [config.path]: config.value
          };
        }

        if (config.path.includes('cta_container')) {
          state.aboutUsPageConfigs.cta_container_section = {
            ...state.aboutUsPageConfigs.cta_container_section,
            [config.path]: config.value
          };
        }
      });

      state.loadingAboutUsPageConfigs = false;
      break;
    }

    case GET_ABOUT_US_PAGE_CONFIGS_FAILED: {
      state.loadingAboutUsPageConfigs = false;
      break;
    }

    case CHANGE_ABOUT_US_PAGE_CONFIGS: {
      const { configPath, checked, configType, value } = action;

      const isConfigExist = state.aboutUsPageConfigsToUpdate.find((config) => config.path === configPath);

      if (configType === 'checkbox') {
        if (isConfigExist) {
          state.aboutUsPageConfigsToUpdate = state.aboutUsPageConfigsToUpdate.map((config) => (
            config.path === configPath ? {...config, value: checked ? 1 : 0} : config
          ));
        } else {
          state.aboutUsPageConfigsToUpdate = [
            ...state.aboutUsPageConfigsToUpdate,
            {path: configPath, value: checked ? 1 : 0}
          ];
        }
      }

      if (configType === 'text' || configType === 'textarea') {
        isConfigExist ?
          state.aboutUsPageConfigsToUpdate = state.aboutUsPageConfigsToUpdate.map((config) => (
            config.path === configPath ? {...config, value} : config
          ))
          :
          state.aboutUsPageConfigsToUpdate = [
            ...state.aboutUsPageConfigsToUpdate,
            {path: configPath, value}
          ];
      }

      break;
    }

    case SAVE_ABOUT_US_PAGE_CONFIGS_START: {
      state.savingAboutUsPageConfigs = true;
      break;
    }

    case SAVE_ABOUT_US_PAGE_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      config.forEach((config) => {
        if (config.path.includes('is_about_us_page_enabled')) {
          state.aboutUsPageConfigs.general = {
            ...state.aboutUsPageConfigs.general,
            [config.path]: config.value
          };
        }

        if (config.path.includes('top_banner')) {
          state.aboutUsPageConfigs.page_top_banner = {
            ...state.aboutUsPageConfigs.page_top_banner,
            [config.path]: config.value
          };
        }

        if (config.path.includes('main_content')) {
          state.aboutUsPageConfigs.main_welcome_section = {
            ...state.aboutUsPageConfigs.main_welcome_section,
            [config.path]: config.value
          };
        }

        if (config.path.includes('provider_section')) {
          state.aboutUsPageConfigs.provider_section = {
            ...state.aboutUsPageConfigs.provider_section,
            [config.path]: config.value
          };
        }

        if (config.path.includes('cta_full')) {
          state.aboutUsPageConfigs.cta_full_section = {
            ...state.aboutUsPageConfigs.cta_full_section,
            [config.path]: config.value
          };
        }

        if (config.path.includes('cta_container')) {
          state.aboutUsPageConfigs.cta_container_section = {
            ...state.aboutUsPageConfigs.cta_container_section,
            [config.path]: config.value
          };
        }
      });

      state.aboutUsPageConfigsToUpdate = initialState.aboutUsPageConfigsToUpdate;
      state.savingAboutUsPageConfigs = false;
      break;
    }

    case SAVE_ABOUT_US_PAGE_CONFIGS_FAILED: {
      state.savingAboutUsPageConfigs = false;
      break;
    }

    case GET_BEFORE_AFTER_GALLERY_CONFIGS_START: {
      state.loadingBeforeAfterGalleryConfigs = true;
      break;
    }

    case GET_BEFORE_AFTER_GALLERY_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      config.forEach((config) => {
        state.beforeAfterGalleryConfigs = {
          ...state.beforeAfterGalleryConfigs,
          [config.path]: config.value
        };
      });

      state.loadingBeforeAfterGalleryConfigs = false;
      break;
    }

    case GET_BEFORE_AFTER_GALLERY_CONFIGS_FAILED: {
      state.loadingBeforeAfterGalleryConfigs = false;
      break;
    }

    case SAVE_BEFORE_AFTER_GALLERY_CONFIGS_START: {
      state.savingBeforeAfterGalleryConfigs = true;
      break;
    }

    case SAVE_BEFORE_AFTER_GALLERY_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      config.forEach((config) => {
        state.beforeAfterGalleryConfigs = {
          ...state.beforeAfterGalleryConfigs,
          [config.path]: config.value
        };
      });

      state.savingBeforeAfterGalleryConfigs = false;
      break;
    }

    case SAVE_BEFORE_AFTER_GALLERY_CONFIGS_FAILED: {
      state.savingBeforeAfterGalleryConfigs = false;
      break;
    }

    case GET_STORE_CONTACTS_CONFIGS_START: {
      state.loadingStoreContactsConfigs = true;
      break;
    }

    case GET_STORE_CONTACTS_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      state.storeContacts = config.reduce((acc, item) => {
        const name = item.path.includes('trans_email/ident_general')
          ? item.path.replace('trans_email/ident_general/', '')
          : item.path.replace('general/store_information/', '');
        return {
          ...acc,
          [name]: item.value
        };
      }, {});
      state.loadingStoreContactsConfigs = false;
      break;
    }

    case GET_STORE_CONTACTS_CONFIGS_FAILED: {
      state.loadingStoreContactsConfigs = false;
      break;
    }

    case SAVE_STORE_CONTACTS_CONFIGS_START: {
      state.savingStoreContactsConfigs = true;
      break;
    }

    case SAVE_STORE_CONTACTS_CONFIGS_SUCCESS: {
      const {data: {config}} = action;

      const uppdatedConfigs = config.reduce((acc, item) => {
        const name = item.path.includes('trans_email/ident_general')
          ? item.path.replace('trans_email/ident_general/', '')
          : item.path.replace('general/store_information/', '');
        return {
          ...acc,
          [name]: item.value
        };
      }, {});
      state.storeContacts = {...state.storeContacts, ...uppdatedConfigs};
      state.savingStoreContactsConfigs = false;
      break;
    }

    case SAVE_STORE_CONTACTS_CONFIGS_FAILED: {
      state.savingStoreContactsConfigs = false;
      break;
    }

    case SAVE_STORE_NAME_START: {
      state.savingStoreName = true;
      break;
    }

    case SAVE_STORE_NAME_SUCCESS: {
      const { data } = action;

      state.storeContacts = {...state.storeContacts, name: data};
      state.savingStoreName = false;
      break;
    }

    case SAVE_STORE_NAME_FAILED: {
      state.savingStoreName = false;
      break;
    }

    case GET_STORE_EMAILS_CONFIGS_START: {
      state.loadingStoreEmailsConfigs = true;
      break;
    }

    case GET_STORE_EMAILS_CONFIGS_SUCCESS: {
      const {data} = action;

      state.storeEmailsConfigs = data.config;
      state.loadingStoreEmailsConfigs = false;
      break;
    }

    case GET_STORE_EMAILS_CONFIGS_FAILED: {
      state.loadingStoreEmailsConfigs = false;
      break;
    }

    case CHANGE_STORE_EMAILS_CONFIGS: {
      const {checked, name} = action;

      state.storeEmailsConfigs = state.storeEmailsConfigs.map((config) => config.path === name ? {...config, value: checked ? 1 : 0} : config);
      state.storeEmailsConfigsToUpdate = [...state.storeEmailsConfigsToUpdate, {
        path: name,
        value: checked ? 1 : 0
      }];
      break;
    }

    case GET_STORE_CONFIGS_SUMMARY_START: {
      state.loadingStoreConfigsSummary = true;
      break;
    }

    case GET_STORE_CONFIGS_SUMMARY_SUCCESS: {
      const {data} = action;

      state.storeConfigsSummary = data.items.sort((a, b) => (a.group > b.group && 1) || -1);
      state.storeConfigsSummaryUpdatedAt = data.updatedAt;
      state.loadingStoreConfigsSummary = false;
      break;
    }

    case GET_STORE_CONFIGS_SUMMARY_FAILED: {
      state.loadingStoreConfigsSummary = false;
      break;
    }

    case CHANGE_HOMEPAGE_CATEGORY_VALUE: {
      const { categoryId, name, value, path } = action;

      if (name === 'name') {
        const categoryIndex = state.homepageCategoryIds.indexOf(String(categoryId));
        state.homepageCategoryNames[categoryIndex] = value;
        state.homepageCategoriesConfigs = state.homepageCategoriesConfigs.map((config) => config.path === path ? {...config, value} : config);
      }

      break;
    }

    case GET_STORE_EMAILS_STYLE_START: {
      state.loadingStoreEmailsStyleTemplate = true;
      break;
    }

    case GET_STORE_EMAILS_STYLE_SUCCESS: {
      const {data} = action;

      state.storeEmailsStyleTemplate = data.config[0].value;
      state.loadingStoreEmailsStyleTemplate = false;
      break;
    }

    case GET_STORE_EMAILS_STYLE_FAILED: {
      state.loadingStoreEmailsStyleTemplate = false;
      break;
    }

    case CHANGE_STORE_EMAILS_STYLE_TEMPLATE: {
      const {value} = action;

      state.storeEmailsStyleTemplate = value;

      const isAlreadyExist = state.storeEmailsConfigsToUpdate.find((config) => (
        config.path === 'asset_manager/email_image_style/email_style'
      ));

      isAlreadyExist ?
        state.storeEmailsConfigsToUpdate = state.storeEmailsConfigsToUpdate.map((config) => (
          config.path === 'asset_manager/email_image_style/email_style'
            ? {...config, value}
            : config
        ))
        :
        state.storeEmailsConfigsToUpdate = [...state.storeEmailsConfigsToUpdate, {
          path: 'asset_manager/email_image_style/email_style',
          value
        }];

      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.storeConfigs = [];
      state.storeConfigsSummary = [];
      state.storeEmailsData = [];
      state.storeSocialMediaConfigs = [];
      state.storeSurveyQuestionConfigs = [];
      state.appointmentBlockConfigs = [];
      state.storeEmailsStyleTemplate = '';
      state.storeEmailsConfigs = [];
      state.fueActiveCampaign = [];
      state.homepageInstagramBlockConfigs = [];
      state.homepageRewardBlockConfigs = [];
      state.homepageWelcomeBlockConfigs = [];
      state.isDepositIntegrated = false;

      break;
    }

    case SET_SETTINGS_ACTIVE_TAB: {
      const {data} = action;
      state.settingsActiveTab = data;

      break;
    }

    case GET_PAYMENT_INTEGRATIONS_START: {
      state.loadingStorePaymentsIntegrations = true;
      break;
    }

    case GET_PAYMENT_INTEGRATIONS_SUCCESS: {
      const { config } = action.data;

      const nextechConfigValue = config.find((item) => item.path.includes('nextech/nextech/enable')).value;
      const modmedConfigValue = config.find((item) => item.path.includes('modmed/modmed/enable')).value;

      state.isNextechIntegrated = nextechConfigValue == 1;
      state.isModMedIntegrated = modmedConfigValue == 1;

      state.loadingStorePaymentsIntegrations = false;
      break;
    }

    case GET_PAYMENT_INTEGRATIONS_FAILED: {
      state.loadingStorePaymentsIntegrations = false;
      break;
    }

    case GET_STORE_EMAILS_CONFIGS_DATA_START: {
      state.loadingStoreEmailsDataConfigs = true;
      break;
    }

    case GET_STORE_EMAILS_CONFIGS_DATA_SUCCESS: {
      const { config } = action.data;

      state.storeEmailsData = config;
      state.loadingStoreEmailsDataConfigs = false;
      break;
    }

    case GET_STORE_EMAILS_CONFIGS_DATA_FAILED: {
      state.loadingStoreEmailsDataConfigs = false;
      break;
    }

    case SAVE_STORE_EMAILS_CONFIGS_DATA_START: {
      state.loadingStoreEmailsDataConfigs = true;
      break;
    }

    case SAVE_STORE_EMAILS_CONFIGS_DATA_SUCCESS: {
      const { config } = action.data;

      state.storeEmailsData = state.storeEmailsData.map((previousConfig) => {
        const updatedConfig = config.find((newConfig) => newConfig.path == previousConfig.path);

        return updatedConfig ? updatedConfig : previousConfig;
      });

      state.loadingStoreEmailsDataConfigs = false;
      break;
    }

    case SAVE_STORE_EMAILS_CONFIGS_DATA_FAILED: {
      state.loadingStoreEmailsDataConfigs = false;
      break;
    }

    case GET_REQUEST_ACCESS_CONFIGS_START: {
      state.loadingRequestAccessConfig = true;
      break;
    }

    case GET_REQUEST_ACCESS_CONFIGS_SUCCESS: {
      const { config } = action.data;
      state.isEnabledRequestAccess = config[0].value == '1';
      state.loadingRequestAccessConfig = false;
      break;
    }

    case GET_REQUEST_ACCESS_CONFIGS_FAILED: {
      state.loadingRequestAccessConfig = false;
      break;
    }


    case GET_DEPOSIT_CONFIG_START: {
      state.loadingDepositConfig = true;
      break;
    }

    case GET_DEPOSIT_CONFIG_SUCCESS: {
      const { config } = action.data;
      state.isDepositIntegrated = config[0].value == '1';
      state.loadingDepositConfig = false;
      break;
    }

    case GET_DEPOSIT_CONFIG_FAILED: {
      state.loadingDepositConfig = false;
      break;
    }

    case GET_SARP_UPDATE_CONFIG_START: {
      state.loadingSARPUpdateConfig = true;
      break;
    }

    case GET_SARP_UPDATE_CONFIG_SUCCESS: {
      const { config } = action.data;
      state.isSARPUpdateEnabled = config[0].value == '1';
      state.loadingSARPUpdateConfig = false;
      break;
    }

    case GET_SARP_UPDATE_CONFIG_FAILED: {
      state.loadingSARPUpdateConfig = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
